import { useState, useEffect, useCallback } from 'react'
import { db } from '../lib/supabase'

export function useTeam() {
  const [members, setMembers] = useState([])
  const [assignments, setAssignments] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchTeam = useCallback(async () => {
    setLoading(true)
    const [{ data: teamData, error: teamError }, { data: assignmentData, error: assignmentError }] = await Promise.all([
      db.getTeamMembers(),
      db.getProductAssignments(),
    ])

    if (teamError || assignmentError) {
      setError(teamError || assignmentError)
    } else {
      setMembers(teamData)
      setAssignments(assignmentData)
    }
    setLoading(false)
  }, [])

  useEffect(() => {
    fetchTeam()
  }, [fetchTeam])

  const createTeamMember = async (member) => {
    const { data, error } = await db.createTeamMember(member)
    if (!error && data) {
      setMembers(prev => [...prev, data])
    }
    return { data, error }
  }

  const updateTeamMember = async (id, updates) => {
    const { data, error } = await db.updateTeamMember(id, updates)
    if (!error && data) {
      setMembers(prev => prev.map(m => m.id === id ? data : m))
    }
    return { data, error }
  }

  const createAssignment = async (assignment) => {
    const { data, error } = await db.createProductAssignment(assignment)
    if (!error && data) {
      setAssignments(prev => [data, ...prev])
    }
    return { data, error }
  }

  return {
    members,
    assignments,
    loading,
    error,
    refetch: fetchTeam,
    createTeamMember,
    updateTeamMember,
    createAssignment,
  }
}

export default useTeam
